export default "__VITE_ASSET__77f2b3dc__"